import { useSelector } from 'react-redux';
import { useGetTasksQuery } from '../../../features/tasks/tasksApi'
import TaskItem from "./TaskItem";

export default function TaskList() {
  const { selectedProjectIds, queryString } = useSelector(state => state.tasksFilter)
  const { data: tasks, isLoading, isError,refetch } = useGetTasksQuery()


  const filterByProject = (task)=>{
      if(selectedProjectIds?.length && selectedProjectIds.includes(task?.project?.id)){
        return true;
      }
      return false;
  }

  const filterByQueryStr = (task) => {
    if (queryString != '') {
      return task?.taskName?.toLowerCase().includes(queryString.toLowerCase());
    }
    return true;
  };
  return (
    <div className="lws-task-list">
      {
        tasks?.length ?
          tasks
          .filter(filterByProject)
          .filter(filterByQueryStr)
          .map(task => (
            <TaskItem key={task?.id} task={task} />
          ))
          :
          <div>Tasks Not Found</div>
      }
    </div>
  )
}